"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalUserRegistrationApprovalDto = void 0;
const external_user_registration_approval_decision_enum_1 = require("./external-user-registration-approval-decision.enum");
class ExternalUserRegistrationApprovalDto {
    constructor() {
        this.decision = external_user_registration_approval_decision_enum_1.ExternalUserRegistrationApprovalDecision.requested;
        this.createdAt = new Date();
        this.userId = '';
        this.validFor = 3;
    }
}
exports.ExternalUserRegistrationApprovalDto = ExternalUserRegistrationApprovalDto;
//# sourceMappingURL=external-user-registration-approval.dto.js.map